// eslint-disable-next-line import/extensions
import JsonExcel from 'vue-json-excel'
import { FormContainer, FormItem, BContainer, HomeContainer, InfoIcon } from '../components/index'

const GlobalComponents = {
  install(Vue) {
    Vue.component(FormContainer.name, FormContainer)
    Vue.component(FormItem.name, FormItem)
    Vue.component(BContainer.name, BContainer)
    Vue.component(HomeContainer.name, HomeContainer)
    Vue.component(InfoIcon.name, InfoIcon)
    Vue.component('DownloadExcel', JsonExcel)
  }
}

export default GlobalComponents
